import { Text, Box, Stack, Span } from "@chakra-ui/react";
import type { IconType } from "react-icons/lib";
import {
  fieldContentColumnStyle,
  fieldContentStyle,
  fieldLabelStyle,
} from "./field";
import { InfoTip } from "../ui/toggle-tip";
import { Alert } from "../ui/alert";

interface FormLabelProps extends React.ComponentProps<"div"> {
  label: string | React.ReactNode;
  labelIcon?: IconType;
  helperText?: string;
  labelProps?: React.ComponentProps<typeof Text>;
  isInfoTip?: boolean;
  disabled?: boolean;
  disableLabel?: boolean;
  children: React.ReactNode | undefined;
  infoTipColor?: string;

  [key: string]: any;
}

const FormLabel = ({
  label,
  disabled = false,
  labelProps,
  isInfoTip = true,
  helperText,
  disableLabel = false,
  labelContainerFlexDirection = "row",
  children,
  infoTipColor,
  ...rest
}: FormLabelProps) => {
  const helperTextValue = helperText
    ? helperText
    : `Please provide ${typeof label === "string" ? label : "this field"}`;

  return (
    <Stack
      {...(labelContainerFlexDirection === "row"
        ? (fieldContentStyle as any)
        : (fieldContentColumnStyle as any))}
      textStyle="fieldContent"
      _disabled={
        (disableLabel || disabled) && {
          opacity: 0.5,
          cursor: "not-allowed",
        }
      }
      {...rest}
    >
      <Box
        {...(fieldLabelStyle as any)}
        textStyle="fieldLabel"
        display="flex"
        {...labelProps}
      >
        {typeof label === "string" ? `${label} :` : label}
        {isInfoTip && (
          <Span ml={2}>
            <InfoTip buttonColor={infoTipColor}>
              <Alert>{helperTextValue}</Alert>
            </InfoTip>
          </Span>
        )}
      </Box>

      {typeof children === "string" ||
      typeof children === "number" ||
      typeof children === "boolean" ? (
        <Text>{children}</Text>
      ) : (
        children
      )}
      {!children && <Alert status="warning">{helperTextValue}</Alert>}
    </Stack>
  );
};

export default FormLabel;
